<div class="reset-password-page">
  <div class="reset-password-container">
    <!-- Logo -->
    <div class="logo">
      <i class="fa fa-cubes"></i>
    </div>

    <!-- Header -->
    <div class="reset-password-header">
      <h2>Réinitialiser le mot de passe</h2>
      <p>Entrez votre nouveau mot de passe</p>
    </div>

    <!-- Success State -->
    <div *ngIf="isPasswordReset" class="success-container">
      <div class="success-message">
        <i class="fa fa-check-circle"></i>
        <span>{{ successMessage }}</span>
      </div>
    </div>

    <!-- Error Message -->
    <div class="error-container" *ngIf="errorMessage && !isPasswordReset">
      <div class="error-message">
        <i class="fa fa-exclamation-circle"></i>
        <span>{{ errorMessage }}</span>
      </div>
    </div>

    <!-- Reset Password Form -->
    <form *ngIf="!isPasswordReset" (ngSubmit)="onSubmit()" #resetPasswordForm="ngForm" class="reset-password-form">
      <div class="form-group">
        <label for="password">Nouveau mot de passe</label>
        <div class="input-group">
          <i class="fa fa-lock"></i>
          <input 
            [type]="showPassword ? 'text' : 'password'"
            id="password"
            [(ngModel)]="password" 
            name="password" 
            placeholder="Entrez votre nouveau mot de passe"
            autocomplete="new-password"
            required
            minlength="8"
            #passwordInput="ngModel">
          <button 
            type="button" 
            class="password-toggle" 
            (click)="showPassword = !showPassword">
            <i class="fa" [class.fa-eye]="!showPassword" [class.fa-eye-slash]="showPassword"></i>
          </button>
        </div>
        <div class="error-hint" *ngIf="passwordInput.invalid && passwordInput.touched">
          Le mot de passe doit contenir au moins 8 caractères
        </div>
      </div>

      <div class="form-group">
        <label for="confirmPassword">Confirmer le mot de passe</label>
        <div class="input-group">
          <i class="fa fa-lock"></i>
          <input 
            [type]="showConfirmPassword ? 'text' : 'password'"
            id="confirmPassword"
            [(ngModel)]="confirmPassword" 
            name="confirmPassword" 
            placeholder="Confirmez votre nouveau mot de passe"
            autocomplete="new-password"
            required
            #confirmPasswordInput="ngModel">
          <button 
            type="button" 
            class="password-toggle" 
            (click)="showConfirmPassword = !showConfirmPassword">
            <i class="fa" [class.fa-eye]="!showConfirmPassword" [class.fa-eye-slash]="showConfirmPassword"></i>
          </button>
        </div>
        <div class="error-hint" *ngIf="confirmPasswordInput.touched && password !== confirmPassword">
          Les mots de passe ne correspondent pas
        </div>
      </div>

      <button 
        type="submit" 
        class="reset-password-button" 
        [disabled]="resetPasswordForm.invalid || isLoading || password !== confirmPassword"
        [class.loading]="isLoading">
        <span *ngIf="!isLoading">Réinitialiser le mot de passe</span>
        <div class="loader" *ngIf="isLoading">
          <div class="spinner"></div>
        </div>
      </button>
    </form>

    <div class="divider">
      <span>ou</span>
    </div>

    <div class="navigation-links">
      <div class="back-to-login">
        <a (click)="goToLogin()" class="back-link">
          Retour à la connexion
        </a>
      </div>
      
      <div class="forgot-password-prompt">
        <a (click)="goToForgotPassword()" class="forgot-link">
          Demander un nouveau lien
        </a>
      </div>
    </div>
  </div>
</div> 